import React from "react";
import "./_teams.scss";

const Teams = () => {
  return (
    <div className="teams">
      <div className="teams__content">
        <h5 className="teams__content__title">
          Equipos de profesionales especializados en la limpieza de todo tipo de
          superficies en altura
        </h5>
        <p className="teams__content__text">
          Nuestro equipos y operarios cuentan con Seguros de altura ilimitado,
          programas de seguridad e higiene y Elementos de protección personal
          (EPP) homologados por profesionales. Contamos con experiencia,
          excelencia y referencias comprobables de todos nuestros clientes:
          particulares, locales, consorcios, empresas e instituciones, que nos
          distinguen como Servicios Premium.
        </p>
      </div>
    </div>
  );
};

export default Teams;
